import { fn, hash } from '@ember/helper';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismInput } from '@mylighthouse/prism-ember';
import { task } from 'ember-concurrency';
import { t } from 'ember-intl';
import { timeout } from 'lumen/utils/waiters';
import { localCopy } from 'tracked-toolbox';

interface ParityParityManagerInputFieldSearchSignature {
  Args: {
    searchValue: string;
    toggleSearch: (value: boolean) => void;
    updateSearchValue: (value: string) => void;
  };
}

export default class ParityParityManagerInputFieldSearch extends Component<ParityParityManagerInputFieldSearchSignature> {
  @localCopy('args.searchValue') declare inputSearchValue: string;

  debouncedSearchValueUpdateTask = task(
    { restartable: true },
    async (value: string): Promise<void> => {
      await timeout();
      this.args.updateSearchValue(value);
    },
  );

  @action onChangeAction(event: Event): void {
    const { value } = event.target as HTMLInputElement;
    this.inputSearchValue = value;
    void this.debouncedSearchValueUpdateTask.perform(value);
  }

  <template>
    <PrismInput
      @autofocus={{true}}
      @iconAfter={{hash name="search"}}
      @onBlur={{fn @toggleSearch false}}
      @onInput={{this.onChangeAction}}
      @placeholder={{t "general.search_placeholder"}}
      @value={{this.inputSearchValue}}
    />
  </template>
}
